import 'typeface-roboto/index.css'
import '@mdi/font/css/materialdesignicons.css'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import log from './plugins/log'
import utilI18N from './plugins/utilI18N'
import vuetify from './plugins/vuetify'
import traductor from './plugins/traductor'
import directivaInputfilter from './plugins/directivaInputfilter'

import api from './api'
import menu from './menu'

import TablasConsulta from './tablasConsulta'
import ControlVersionAplicacion from './controlVersionAplicacion'

import screenfull from 'screenfull'
import { Settings } from "luxon"

Vue.config.productionTip = (process.env.NODE_ENV !== 'production');

Vue.use (log);
Vue.use (utilI18N);
Vue.use (traductor);
Vue.use (directivaInputfilter);

// añadimos a los objetos la funcion "safeGet", para leer propiedades hijas sin problemas con posibles padres "undefined"
Object.defineProperty(Object.prototype, 'safeGet', {
  enumerable: false,
  writable: false,
  value: function(prop, def = undefined) {
      let res = prop.split('.').reduce((acc, k) => {
          if (acc && k in acc) return acc[k];
          return undefined;
      }, this);
      return (res != undefined) ? res : def;
  }
});

// Objeto reactivo accesible globalmente
Vue.prototype.$global = new Vue({
  data: {
    enModoPantallaCompleta: undefined,
    identificadorInterfoniaAGestionar: undefined,
    estadoInstalaciones: undefined,
    estadoAparatos: undefined,
    ultimasIncidenciasAparatos: undefined,
    notificacionesIncidencias: undefined
  },
  methods: {
    inicializar () {
      this.enModoPantallaCompleta = null;
      this.identificadorInterfoniaAGestionar = null;
      this.estadoInstalaciones = {};
      this.estadoAparatos = {};
      this.ultimasIncidenciasAparatos = {};
      this.notificacionesIncidencias = [];
    },
    inicializarEstadoConexionAparatosInstalacion (id_instalacion) {
      let idInstalacion4digitos = String (id_instalacion).padStart (4, "0");
      // establezco/inicializo el valor de la propiedad "on_line" de todos los aparatos del la instalación
      Object.keys (this.estadoAparatos).forEach ((codigo_aparato) => {
        if (codigo_aparato.substring (0,4) == idInstalacion4digitos) {
          Vue.set (this.estadoAparatos [codigo_aparato], 'on_line', false);
        }
      });
    },
    actualizarEstadoInstalaciones () {
      api.obtenerEstadoInstalaciones()
        .then ((respuesta) => {
          let instalaciones = respuesta.data.instalaciones;
          instalaciones.forEach ((instalacion) => {
            let objetoEstadoInstalacion = this.$global.estadoInstalaciones [instalacion.id_ins];
            if (objetoEstadoInstalacion == undefined)
              objetoEstadoInstalacion = {};
            objetoEstadoInstalacion.id = instalacion.id_ins;
            objetoEstadoInstalacion.nombre = instalacion.nom;
            objetoEstadoInstalacion.total_plazas = instalacion.totpla;
            objetoEstadoInstalacion.zonas = JSON.parse (instalacion.zon);
            objetoEstadoInstalacion.contadores = JSON.parse (instalacion.con);
            objetoEstadoInstalacion.carteles = JSON.parse (instalacion.car);
            this.$set (this.estadoInstalaciones, instalacion.id_ins, objetoEstadoInstalacion);
          });
          //console.log (JSON.stringify (this.$global.estadoInstalaciones, null, 2));
        });
    }
  },
  created() {
    this.inicializar();
  }
});

// sincronizamos nuestra variable global con el modo de pantalla actual
if (screenfull.isEnabled) {
  screenfull.onchange (() => {
    Vue.prototype.$global.enModoPantallaCompleta = screenfull.isFullscreen;
  });
}

// console.log ('solicitando parametros de configuración...');
api.obtenerParametrosConfiguracion()
  .then ((respuesta) => {
    try {
      // Parámetros de configuración
      // console.log ('Parametros de configuracion:', respuesta.data.parametros_configuracion);
      Vue.prototype.$parametros_configuracion = respuesta.data.parametros_configuracion;

      // inyectamos de forma dinamica y global el estilo CSS especifico de la instancia
      let file = document.createElement('link');
      file.rel = 'stylesheet';
      file.href = process.env.VUE_APP_URL_BASE_FRONTEND + Vue.prototype.$parametros_configuracion.rutassins + '/estiloGlobal.css';
      document.head.appendChild(file)

      // establecemos la configuración regional en Luxon
      Settings.defaultLocale = Vue.prototype.$parametros_configuracion.codpaiconreg;

      // cargamos las traducciones enviadas junto con los parámetros de configuracion:
      // console.log ('Traducciones:', respuesta.data.traducciones);
      Vue.prototype.$traductor.establecerTraducciones (respuesta.data.traducciones);

      // Añadimos las rutas del menu del panel para cuando el operador haya iniciado sesión
      router.addRoutes (menu.arrayRutasPanel());

      // preparamos las Tablas de consulta...
      Vue.prototype.$tablasConsulta = new TablasConsulta ();

      // instalamos el controlador de version de aplicacion
      new ControlVersionAplicacion (api.instanciaAxios);

      // establecemos el estado incial: Recuperamos la sesión con un posible token de acceso almacenado
      store.RECUPERAR_SESION ()
        .catch (() => {
          // si hay un error recuperando la sesión, lo ignoramos, y empezamos de 0
        })
        .finally (() => {
          // finalmente, creamos la App
          const app = new Vue({
            router,
            store,
            vuetify,
            render: h => h(App)
          }).$mount('#app')

          // establecemos la configuración regional en Vuetify
          app.$vuetify.lang.current = app.$parametros_configuracion.codpaiconreg;
        });

    } catch (e) {
      console.error (e);
    }
  })
  .catch ((e) => {
    console.error ("No se han podido obtener los parámetros de configuración. Ejecución abortada.", e)
  });
